<div
  *ngIf="showMessage$ | async"
  class="alert-banner"
  [ngClass]="{ error: isError, warn: isWarn }"
  (click)="handleAlertClick()"
  @fadeOut
  (@fadeOut.done)="fadeFinished($event)"
>
  <mat-card class="mat-elevation-z3">
    <mat-card-header>
      <div mat-card-avatar>
        <capra-icon icon="icon-check-outline" *ngIf="!isError && !isWarn"></capra-icon>
        <capra-icon icon="icon-warning" *ngIf="isWarn"></capra-icon>
        <capra-icon icon="icon-info-outline" *ngIf="isError"></capra-icon>
      </div>
      <mat-card-title>{{text}}</mat-card-title>
    </mat-card-header>
    <mat-card-actions *ngIf="displayActions">
      <ng-content select="[secondary-button]"></ng-content>
      <ng-content select="[primary-button]"></ng-content>
    </mat-card-actions>
  </mat-card>
</div>
